import { render, staticRenderFns } from "./precautions.vue?vue&type=template&id=6f7100d0&scoped=true"
import script from "./precautions.vue?vue&type=script&lang=js"
export * from "./precautions.vue?vue&type=script&lang=js"
import style0 from "./precautions.vue?vue&type=style&index=0&id=6f7100d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7100d0",
  null
  
)

export default component.exports